module.exports = __webpack_public_path__ + "static/img/icons_payments_and_invoices_blue.5d67154.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_payments_and_invoices_blue.svg
// module id = WZhX
// module chunks = 1